module.exports = __webpack_public_path__ + "static/media/backsplash1.dd6eb7b9.jpg";